<template lang="pug">
  figure.full-video
    video(
      ref="player"
      class="video-js vjs-city-offer vjs-show-big-play-button-on-pause"
      controls
      playsinline
      :width="media.video.width"
      :height="media.video.height"
    )
      source(:src="src" :type="mime")
</template>

<script>
import videojs from 'video.js';
import 'videojs-http-source-selector';
import 'videojs-contrib-quality-levels';

import { debounce } from '@/helpers';

import PreviewVideo from './PreviewVideo';
export default {
    name: 'FullVideo',
    extends: PreviewVideo,
    props: {
        play: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        maxHeight: undefined
    }),
    watch: {
        play(to) {
            if (to) {
                this.player.currentTime(0);
                this.player.play();
            } else {
                this.player.pause();
            }
        }
    },
    computed: {
        options() {
            return {
                muted: true,
                language: 'en',
                preload: 'auto',
                fluid: false,
                // aspectRatio: `${parseInt(this.width)}:${parseInt(this.height)}`,
                // autoplay: true,
                // inactivityTimeout: 1,
                html5: {
                    hls: {
                        overrideNative: true,
                        limitRenditionByPlayerDimensions: true,
                        useDevicePixelRatio: true,
                        bandwidth: 16777216
                    },
                    nativeAudioTracks: false,
                    nativeVideoTracks: false,
                    useBandwidthFromLocalStorage: true
                },
                controlBar: {
                    pictureInPictureToggle: false
                }
                // plugins: {
                //   hlsQualitySelector: {
                //     displayCurrentQuality: true,
                //   }
                // }
            };
        }
    },
    methods: {
        initialise() {
            this.player = videojs(this.$refs.player, this.options);
            this.player.httpSourceSelector();

            // this.player.controls(false)

            this.player.on('ended', () => {
                this.player.posterImage.show();
                // vid.bigPlayButton.show();
                this.player.currentTime(0);
            });

            this.player.on('touchstart', event => {
                // this.$refs.player.parentNode.classList.add('vjs-show-controls');
                if (event.target.nodeName === 'VIDEO') {
                    if (this.player.paused()) this.player.play();
                    else this.player.pause();
                }
            });

            videojs.log.level('error');
        }
    },
    mounted() {
        const ratio = this.media.video.width / this.media.video.height;
        const updateVideoHeight = () => {
            this.maxHeight = Math.min(this.media.video.height, window.innerWidth / ratio, window.innerHeight * 0.8);
            if (this.player) this.player.height(this.maxHeight);
        };
        window.addEventListener('resize', debounce(updateVideoHeight, 100));
        updateVideoHeight();
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
figure
  @apply bg-gray-200
  position: relative
  .video-js
    // position: absolute
    // left: 0
    // top: 0
    // height: 100%
    width: 100%
</style>
